/* eslint-disable */
!(function (e) {
    var t,
        n,
        o,
        i,
        d,
        c,
        a =
            '<svg><symbol id="icon-i-icon" viewBox="0 0 1024 1024"><path d="M512 85.333333a425.344 425.344 0 0 1 301.696 124.970667A425.344 425.344 0 0 1 938.666667 512a425.344 425.344 0 0 1-124.970667 301.696A425.344 425.344 0 0 1 512 938.666667a425.344 425.344 0 0 1-301.696-124.970667A425.344 425.344 0 0 1 85.333333 512a425.344 425.344 0 0 1 124.970667-301.696A425.344 425.344 0 0 1 512 85.333333z m10.666667 298.666667h-42.666667l-4.992 0.298667A42.666667 42.666667 0 0 0 480 469.333333v213.333334h-32l-4.992 0.298666A42.666667 42.666667 0 0 0 448 768H597.333333l4.992-0.298667A42.666667 42.666667 0 0 0 597.333333 682.666667h-32v-256l-0.298666-4.992A42.666667 42.666667 0 0 0 522.666667 384z m-7.808-188.970667a58.496 58.496 0 1 0 0 117.034667 58.496 58.496 0 0 0 0-117.034667z"  ></path></symbol></svg>',
        l = (l = document.getElementsByTagName('script'))[l.length - 1].getAttribute('data-injectcss');
    if (l && !e.__iconfont__svg__cssinject__) {
        e.__iconfont__svg__cssinject__ = !0;
        try {
            document.write(
                '<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>',
            );
        } catch (e) {
            console && console.log(e);
        }
    }
    function s() {
        d || ((d = !0), o());
    }
    (t = function () {
        var e, t, n;
        ((n = document.createElement('div')).innerHTML = a),
            (a = null),
            (t = n.getElementsByTagName('svg')[0]) &&
                (t.setAttribute('aria-hidden', 'true'),
                (t.style.position = 'absolute'),
                (t.style.width = 0),
                (t.style.height = 0),
                (t.style.overflow = 'hidden'),
                (e = t),
                (n = document.body).firstChild ? (t = n.firstChild).parentNode.insertBefore(e, t) : n.appendChild(e));
    }),
        document.addEventListener
            ? ~['complete', 'loaded', 'interactive'].indexOf(document.readyState)
                ? setTimeout(t, 0)
                : ((n = function () {
                      document.removeEventListener('DOMContentLoaded', n, !1), t();
                  }),
                  document.addEventListener('DOMContentLoaded', n, !1))
            : document.attachEvent &&
              ((o = t),
              (i = e.document),
              (d = !1),
              (c = function () {
                  try {
                      i.documentElement.doScroll('left');
                  } catch (e) {
                      return void setTimeout(c, 50);
                  }
                  s();
              })(),
              (i.onreadystatechange = function () {
                  'complete' == i.readyState && ((i.onreadystatechange = null), s());
              }));
})(window);
